import React, { useState, useMemo, useRef } from 'react';
import { Button } from 'src/components/ui';
import { QrReader } from 'react-qr-reader';
import { useDebouncedEffect } from '../../hooks/useDebounceEffect';
import { useSideChannelSubscription } from '../../util/useSideChannel';
import getPathFromId from '../../util/getPathFromId';
import { useJnx } from '../../util/jnx';
import Icon from 'src/components/Icon';

function QrRead(props) {
  const {
    formData: value,
    registry,
    onChange,
    fieldPathId: { $id } = {},
    schema: { title },
    uiSchema: { 'ui:onSelect': onSelectExpr },
    required,
  } = props;
  const formContext = registry?.formContext;
  const { setFormDataValues, sideChannel } = formContext;

  const [show, setShow] = useState(false);

  const rootFormData = useSideChannelSubscription(sideChannel, 0);
  // The on-select expression fires ~1s after the scan; read the form data as it is then, not as the
  // debounced effect captured it (which is undefined when the field already has a value on load).
  const rootFormDataRef = useRef(rootFormData);
  rootFormDataRef.current = rootFormData;
  const functionBinds = useMemo(() => ({ set: setFormDataValues }), [setFormDataValues]);
  const onSelectJnx = useJnx(onSelectExpr, { functionBinds });

  const path = useMemo(() => getPathFromId($id), [$id]);

  const clean = () => {
    setShow(false);
    onChange(undefined, path);
  };

  useDebouncedEffect(
    () => {
      if (value) {
        if (onSelectJnx) {
          setTimeout(() => {
            onSelectJnx.eval(rootFormDataRef.current, '', { fieldPath: path, object: value });
          }, 500);
          clean();
        }
      }
    },
    [value],
    450
  );

  return (
    <>
      <label className="control-label">
        {title}
        {required ? <span className="required">*</span> : null}
      </label>
      <div className="">
        {show ? (
          <>
            <Button onClick={() => clean()} title="Cancel">
              <Icon icon="X" weight="regular" className="text-danger" />
            </Button>
            <QrReader
              containerStyle={{ height: '168px' }}
              videoStyle={{ height: '168px', width: '50%' }}
              constraints={{ facingMode: 'environment' }}
              onResult={result => {
                if (result?.text) {
                  onChange(JSON.parse(result.text), path);
                  setShow(false);
                }
              }}
            />
          </>
        ) : (
          <Button onClick={() => setShow(true)}>
            <Icon icon="QrCode" /> Scan QR
          </Button>
        )}
      </div>
    </>
  );
}

export default QrRead;
